import { Link } from "react-router-dom";
import "./product-card-style.scss";

//產品封面卡
//
//  封面有兩種來源，元件自己判斷：
//    item.image  → 有美術圖時用圖
//    否則         → 用 CSS 漸層 + 大字（見 _mixins.scss 的 cover-themes）
//  這樣美術還沒進來也能開發，之後補圖不用改版型。
//
//  size:
//    "md"  一般卡（卡片列用）
//    "lg"  大卡（輪播用）
//    "sm"  小方卡（排行榜縮圖用）
const ProductCard = ({ item, size = "md", showMeta = true }) => {
  const { glyph, theme = "ink", title, subtitle, badge, image, path } = item;

  const inner = (
    <>
      <div
        className={`pc__cover pc__cover--${theme}`}
        style={image ? { backgroundImage: `url(${image})` } : undefined}
      >
        {/* 沒有圖時才顯示大字，有圖就讓圖自己說話 */}
        {!image && <span className="pc__glyph">{glyph}</span>}

        {badge && <span className="pc__badge">{badge}</span>}
      </div>

      {showMeta && (
        <div className="pc__meta">
          <h3 className="pc__title">{title}</h3>
          {subtitle && <p className="pc__subtitle">{subtitle}</p>}
        </div>
      )}
    </>
  );

  const className = `pc pc--${size}`;

  //沒給 path 就不要包 Link —— 包了會變成可點但點了沒反應的死連結
  if (!path) return <div className={className}>{inner}</div>;

  return (
    <Link to={path} className={className}>
      {inner}
    </Link>
  );
};

export default ProductCard;
